import { app } from '../../../app';
import { Controller } from './session-expired.controller';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.session-expired', {
        url: '/sessionExpired',
        controller: Controller,
    })
}



// WEBPACK FOOTER //
// ./src/portal/states/public/session-expired/session-expired.state.js